export interface Property {
  id: string;
  slug: string | null;
  mls_id: string | null;
  title: string;
  description: string | null;
  price: number;
  address: string;
  city: string;
  neighborhood: string | null;
  postal_code: string | null;
  latitude: number | null;
  longitude: number | null;
  property_type: string;
  bedrooms: number;
  bathrooms: number;
  sqft: number | null;
  lot_size: string | null;
  year_built: number | null;
  parking: string | null;
  features: string[] | null;
  images: string[] | null;
  status: string;
  listing_date: string;
  agent_name: string | null;
  agent_phone: string | null;
  agent_email: string | null;
  brokerage_name: string | null;
  created_at: string;
  updated_at: string;
  architectural_style?: string[] | null;
  property_condition?: string[] | null;
}

/** Get the URL path for a property, preferring slug over UUID */
export function getPropertyUrl(property: Pick<Property, 'id' | 'slug'>): string {
  return `/property/${property.slug || property.id}`;
}

export interface PropertyFilters {
  city?: string;
  neighborhood?: string;
  neighborhoods?: string[]; // For filtering by multiple neighborhoods
  minPrice?: number;
  maxPrice?: number;
  propertyType?: string;
  minBedrooms?: number;
  maxBedrooms?: number;
  minBathrooms?: number;
  maxBathrooms?: number;
  minSqft?: number;
  maxSqft?: number;
  minYearBuilt?: number;
  maxYearBuilt?: number;
  parking?: string;
  searchQuery?: string;
  distressed?: boolean;
  /** Optional sub-filter under Distressed: 'bank', 'court' (King's Bench / judicial / foreclosure), or 'probate' (estate sales). */
  distressedType?: 'bank' | 'court' | 'probate';
  /** Multi-select architectural style filter keys (e.g. ['bungalow', 'two_storey']) */
  architecturalStyles?: string[];
  /** Multi-select property condition filter keys (e.g. ['new_or_never_occupied']) */
  propertyConditions?: string[];
}

export interface SavedSearch {
  id: string;
  user_id: string;
  name: string;
  filters: PropertyFilters;
  email_alerts: boolean;
  created_at: string;
  updated_at: string;
}

export interface Favorite {
  id: string;
  user_id: string;
  property_id: string;
  created_at: string;
  property?: Property;
}

export interface RecentlyViewed {
  id: string;
  user_id: string;
  property_id: string;
  viewed_at: string;
  property?: Property;
}

export interface Inquiry {
  id: string;
  user_id: string | null;
  property_id: string;
  name: string;
  email: string;
  phone: string | null;
  message: string;
  created_at: string;
  property?: Property;
}

export interface Profile {
  id: string;
  user_id: string;
  full_name: string | null;
  phone: string | null;
  avatar_url: string | null;
  created_at: string;
  updated_at: string;
}